import React from 'react'

export default function AboutUs() {
  return (
    <div id="about " className=''>
      <a id='about'>
        <section class="bg-white">
          <div class="container px-6 py-5 my-10 mx-auto border border-gray100 rounded-lg shadow-xl ">
            <h1 class="text-4xl font-Montserrat font-semibold text-center text-size-200 text-gray-900 dark:text-black">
              About Us
              </h1>
              <br></br>
              <h1 class="text-2xl font-Montserrat font-semibold text-center text-size-200 text-gray-900 dark:text-black">
              Get your claims at the best price, for plans that include individual group and family plan.
            </h1>
            <div class="grid grid-cols-1 gap-8 mt-8 xl:mt-12 xl:gap-12 md:grid-cols-2 xl:grid-cols-3">
              <div class="p-8 space-y-3 bg-bluiy border-2 border-bluiy dark:border-blue-300 rounded-xl">
                <span class="inline-block text-blue-500 dark:text-blue-400">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
                  </svg>
                </span>

                <h1 class="text-2xl font-semibold text-gray-700 capitalize dark:text-white">WHY US?</h1>

                <p class="text-gray-500 dark:text-gray-300">
                ➤We are a team of professionals, working together to ensure the customer gets value in terms of accuracy and timelines.<br></br>
                ➤We also ensure that the customer receives the best claim amount possible.
                </p>

                
              </div>

              <div class="p-8 space-y-3  bg-bluiy border-bluiy dark:border-blue-300 rounded-xl">
                <span class="inline-block text-blue-500 dark:text-blue-400">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" />
                  </svg>
                </span>

                <h1 class="text-2xl font-semibold text-gray-700 capitalize dark:text-white">SERVICES WE PROVIDE</h1>

                <p class="text-gray-500 dark:text-gray-300">
                ➤We provide you the best platform where you will get the best possible estimation amount that can be claimed for insurance, based on few factors. <br></br>
                ➤We provide this estimated amount on the basis of certain health and general factors.

                </p>

                
              </div>

              <div class="p-8 space-y-3  bg-bluiy border-bluiy border-2 border-blue-400 dark:border-blue-300 rounded-xl">
                <span class="inline-block text-blue-500 dark:text-blue-400">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                  </svg>
                </span>

                <h1 class="text-2xl font-semibold text-gray-700 capitalize dark:text-white">HOW ARE WE DIFFERENT FROM OTHERS?</h1>

                <p class="text-gray-500 dark:text-gray-300">
                ➤Streamlined claims process <br></br>
                ➤Real-time estimates <br></br>
                ➤Pre-insurance eligibility check <br></br>
                ➤User-friendly interface <br></br>
                
                </p>

                
              </div>
            </div>
          </div>
        </section>

       
      </a>
    </div>
  )
}




